import React from "react";

export type MobilePanel = "map" | "brief" | "layers";

interface Props {
  panel: MobilePanel;
  onChange: (p: MobilePanel) => void;
}

// Minimal geometric SVG icons — functional signifiers, not decoration.
// Each is 20×20, strokeWidth 1.5, currentColor so they inherit active/inactive state.
const IconBrief = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
    <rect x="3" y="5"   width="14" height="1.5" rx="0.5" fill="currentColor" />
    <rect x="3" y="9.25" width="10" height="1.5" rx="0.5" fill="currentColor" />
    <rect x="3" y="13.5" width="12" height="1.5" rx="0.5" fill="currentColor" />
  </svg>
);

const IconMap = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
    <path
      d="M10 2C7.24 2 5 4.24 5 7c0 4.25 5 9 5 9s5-4.75 5-9c0-2.76-2.24-5-5-5z"
      stroke="currentColor" strokeWidth="1.5" fill="none"
    />
    <circle cx="10" cy="7" r="1.75" stroke="currentColor" strokeWidth="1.25" />
  </svg>
);

const IconLayers = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
    <path d="M10 3L17 6.5 10 10 3 6.5z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" fill="none" />
    <path d="M3 10l7 3.5 7-3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M3 13.5l7 3.5 7-3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

const TABS: { id: MobilePanel; label: string; sub: string; icon: React.ReactElement }[] = [
  { id: "brief",  label: "STATUS", sub: "AQI · energy",  icon: <IconBrief /> },
  { id: "map",    label: "MAP",    sub: "live twin",      icon: <IconMap /> },
  { id: "layers", label: "LENS",   sub: "layers · feed",  icon: <IconLayers /> },
];

export function MobileNav({ panel, onChange }: Props) {
  return (
    <nav className="mobile-nav" role="tablist" aria-label="Dashboard panels">
      {TABS.map((t) => (
        <button
          key={t.id}
          role="tab"
          aria-selected={panel === t.id}
          className={`mobile-nav-btn${panel === t.id ? " active" : ""}`}
          onClick={() => onChange(t.id)}
        >
          <span className="mobile-nav-icon">{t.icon}</span>
          <span className="mobile-nav-label mono">{t.label}</span>
          <span className="mobile-nav-sub">{t.sub}</span>
        </button>
      ))}
    </nav>
  );
}
